module.exports = __webpack_public_path__ + "img/8.b909291e.jpg";